import React from 'react';
import { mdiThermometer, mdiThermometerLow, mdiThermometerHigh } from '@mdi/js';
import { TemperaturaLeadEnum } from '@tera/shared/src/types/VendaDto';
import { Icon } from '../../components/IconWrapper';

type Props = {
    temperatura: TemperaturaLeadEnum;
};

export const TemperaturaLeadIcon: React.FC<Props> = ({ temperatura }) => {
    const temperatureConfig: Record<TemperaturaLeadEnum, { variant: 'info' | 'gray-500' | 'danger'; icon: string; title: string }> = {
        frio: { variant: 'info', icon: mdiThermometerLow, title: 'Lead frio' },
        normal: { variant: 'gray-500', icon: mdiThermometer, title: 'Lead normal' },
        quente: { variant: 'danger', icon: mdiThermometerHigh, title: 'Lead quente' },
    };

    const variant = temperatureConfig[temperatura].variant ?? 'gray-500';
    const icon = temperatureConfig[temperatura].icon ?? mdiThermometer;
    const title = temperatureConfig[temperatura].title ?? 'Normal';

    return <Icon path={icon} size={0.6} color={`var(--tc-color-${variant})`} title={title} />;
};
